/** How many concerns the page leads with. */
export const WEEKLY_CONCERN_LIMIT = 3;
/**
 * How far ahead the cash section's two-week view looks, in days: one pay cycle.
 *
 * Only cash runs on the two-week cycle. Every other "this week" figure on the
 * page uses the Sunday-to-Saturday week in `weekStart` / `weekEnd`, and cash
 * carries that one-week window too, beside this one.
 */
export const WEEKLY_LOOKAHEAD_DAYS = 14;
export const WEEKLY_SECTIONS = [
    'concerns',
    'cash',
    'collections',
    'budget',
    'production',
    'retainers',
    'trust',
];
/**
 * The grant each section needs, which is the grant of the screen it drills to.
 *
 * `concerns` is gated on `alerts.view` and then filtered per alert by the rule's
 * own grant — so an Executive sees the cash and refund concerns and not the
 * trust ones, exactly as on the alerts page.
 */
export const WEEKLY_SECTION_META = {
    concerns: { label: 'Biggest concerns', permission: 'alerts.view', drillTo: '/alerts' },
    cash: { label: 'Cash position', permission: 'cash_flow.view', drillTo: '/cash-flow' },
    collections: {
        label: 'Receivables and collections',
        permission: 'ar.view',
        drillTo: '/accounts-receivable',
    },
    budget: { label: 'Revenue and expenses vs budget', permission: 'budgets.view', drillTo: '/budget' },
    production: { label: 'Legal production', permission: 'reports.view', drillTo: '/productivity' },
    /**
     * Under the trust grant, because the figure is trust deposits — client money
     * — and it drills to the screen that shows them.
     */
    retainers: {
        label: 'Retainers vs goal',
        permission: 'trust_ledger.view',
        drillTo: '/trust-funding',
    },
    trust: { label: 'Money in trust', permission: 'trust_ledger.view', drillTo: '/trust-funding' },
};
/**
 * What the weekly pack asks for and nothing yet calculates.
 *
 * Rendered as cards that say so, never as zeros. Each one needs data the
 * platform does not hold or a decision the firm has not made, and the reason is
 * printed on the card so it cannot be misquoted as "nothing owed".
 */
export const WEEKLY_NOT_BUILT = [
    {
        label: 'Debt',
        reason: 'Loan balances sync from QuickBooks but no module reads them, and there is no repayment schedule to measure progress against.',
    },
    {
        label: 'Payment plans',
        reason: 'Only one-off promises to pay are recorded. Instalment schedules are not.',
    },
    {
        label: 'Production vs SKU',
        reason: 'There is no service catalogue. The firm needs to define what a SKU is first.',
    },
    {
        label: 'Unusual transactions',
        reason: 'Bank and general-ledger transactions are not synced, so only billing exceptions and refunds are checked today.',
    },
    {
        label: 'Unauthorised spending',
        reason: 'There is no spending approval workflow to compare payments against.',
    },
];
//# sourceMappingURL=weekly.js.map